var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{attrs:{"background":"","current-page":_vm.currentPage,"page-sizes":[20, 30, 50,100],"page-size":20,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagerPro.RecordCount},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.3.0@vue-loader/lib/template-compiler?{"id":"data-v-00410964","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/paging.vue
// module id = null
// module chunks = 